// extracted by mini-css-extract-plugin
export var bgOverlay = "PageHeader-module__bgOverlay___RouhJ";
export var header = "PageHeader-module__header___dlUGS";
export var headerContent = "PageHeader-module__headerContent___NHU+8";
export var heading = "PageHeader-module__heading___wQ4ch";